import { render, staticRenderFns } from "./DynamicDataPromotionVideo.vue?vue&type=template&id=72fc8e4d&"
import script from "./DynamicDataPromotionVideo.vue?vue&type=script&lang=ts&"
export * from "./DynamicDataPromotionVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports